import { style } from '@vanilla-extract/css'

const message = style({
  margin: 0,
  fontSize: '14px',
  lineHeight: 1.6,
  whiteSpace: 'pre-wrap',
})

export const styles = {
  message,
}
